import React from 'react'
import { useTranslation } from "react-i18next";

import { getLocalizedDate } from "../../Utilty/index";
import {Typography} from '@mui/material'

 export   function LocalizateCurrentDate() {
  const { i18n } = useTranslation();
  const now = getLocalizedDate("dddd DD MMMM");

  // مهم: چون i18n.language تغییر می‌کنه ولی تابع بالا مستقیم صدا زده میشه،
  // اگه می‌خوای با تغییر زبان بدون رفرش صفحه هم آپدیت بشه، از useMemo استفاده کن:
  const localizedNow = React.useMemo(
    () => getLocalizedDate("dddd DD MMMM"),
    [i18n.language]
  );

  return <Typography variant='body2' >{localizedNow}</Typography>;
}